import React from "react";

const Button = props => {
  // console.log(props.style);
  return (
    <button
      style={props.style}
      className={
          // props.type == "primary" ? "btn btn-primary" : "btn btn-secondary"
          props.type == "primary" ? "btn btn-primary waves-effect waves-light" : "btn btn-secondary"
          // btn-primary btn-block waves-effect waves-light
      }
      onClick={props.action}
    >
      {props.title}
    </button>
  );
};

export default Button;
